// ********************************************************
//
// IMPORT
//
// ********************************************************
import VConsole from 'vconsole'

import FontService from '@/services/FontService' 
// import WechatService from '@/services/WechatService'
import AssetService from '@/services/AssetService'
// import MediaService from '@/services/MediaService'
/*import SoundService from '@/services/SoundService'*/
import ImageService from '@/services/ImageService'
import '@/services/ResizeService'
import '@/services/AnalyticsService'
import '@/helpers/Raf'


import firebase from 'firebase/app' 
import * as firebaseui from 'firebaseui'

import fontManifest from '@/config/fonts'
import assetManifest from '@/config/asset'
// import mediaManifest from '@/config/media'
/*import soundManifest from '@/config/sound'*/

import store from '@/store'

// ********************************************************
//
// DOCUMENT
//
// ********************************************************
const loadDocument = function() {
  return new Promise((resolve) => {
    const onReady = function() {
      resolve()
    }

    if (document.readyState === 'complete') {
      onReady()
    } else {
      document.onreadystatechange = () => {
        if (document.readyState === 'complete') {
          onReady()
        }
      }
    }
  })
}

// ********************************************************
//
// INIT
//
// ********************************************************
;(async function() {
  await loadDocument()

  console.group('Initialization')

  store.commit('app/setLoadStep', 'vconsole')
  if (store.state.app.vconsole) new VConsole()

  store.commit('app/setLoadStep', 'app')
  await import('./main')

  store.commit('app/setLoadStep', 'fonts')
  await FontService.load(fontManifest)

  store.commit('app/setLoadStep', 'assets')
  await AssetService.load(assetManifest)

  store.commit('app/setLoadStep', 'image')
  await ImageService.load(assetManifest, 2, 'load')
 
  store.commit('app/setLoadStep', 'image')
  await ImageService.load(assetManifest, 2, 'main')

  store.commit('app/setLoadStep', 'completed')
  store.commit('app/setLoadComplete')

  console.groupEnd()
})()
